import { SweepstakeOptions } from '@coin-microservices/sweepstakes-react-hooks'

import { makeContext } from '../../utils'

export const SweepstakesEntrySelected = makeContext<SweepstakeOptions | null>(null, 'entry_selected')
